import { EditorialError, EditorialErrorIdentifier } from '@/components/EditorialErrors/EditorialErrors';

const identifyMissingFromCalendar: EditorialErrorIdentifier = ({
	useSpecies,
	useCalendar,
}) => {
	const { species } = useSpecies;
	const { getDatesFromSpecies } = useCalendar;

	if (!species) return [];

	const errors = species.data
		.map((species) => {
			const dates = getDatesFromSpecies(species.id);
			if (dates.length === 0) {
				return {
					title: 'Mist op kalender',
					description: `Er zijn geen datums voor ${species.attributes.titleShort} gevonden in de kalender.`,
					speciesId: species.id,
				};
			}
			return undefined;
		})
		.filter((error) => error !== undefined) as EditorialError[];

	return errors;
};

export default identifyMissingFromCalendar;
